import React, { RefObject } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

interface ContraindicationsModalProps {
  open: boolean;
  onClose: () => void;
  onAgree: () => void;
  isContraScrollable: boolean;
  isContraScrolledToEnd: boolean;
  contraDialogContentRef: RefObject<HTMLDivElement>;
  onScroll: () => void;
  contraindications: Array<{ id?: string | number; content: string }>;
  t: (_key: string) => string;
}

const ContraindicationsModal: React.FC<ContraindicationsModalProps> = ({
  open,
  onClose,
  onAgree,
  isContraScrollable,
  isContraScrolledToEnd,
  contraDialogContentRef,
  onScroll,
  contraindications,
  t,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    {/* Centered yellow triangle warning icon */}
    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="24,6 44,42 4,42"
          fill="#FFEB3B"
          stroke="#FBC02D"
          strokeWidth="2"
        />
        <rect x="22" y="18" width="4" height="12" rx="2" fill="#FBC02D" />
        <circle cx="24" cy="36" r="2.2" fill="#FBC02D" />
      </svg>
    </div>
    <DialogTitle sx={{ fontWeight: 700, textAlign: "center" }}>
      {t("title.contraindications") || "Contraindications"}
    </DialogTitle>
    <DialogContent
      sx={{
        maxHeight: 360,
        overflowY: "auto",
        minWidth: 320,
        fontWeight: 500,
      }}
      ref={contraDialogContentRef}
      onScroll={onScroll}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
          {t("label.contraindicationsWarning") ||
            "Please review the following contraindications before proceeding:"}
        </Typography>
        <ul style={{ paddingLeft: 20 }}>
          {contraindications?.map((item, idx) => (
            <li
              key={item.id || idx}
              style={{
                marginBottom: 8,
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, minWidth: 28, marginRight: 1 }}
              >
                {idx + 1}.
              </Typography>
              <Typography variant="body2">{item.content}</Typography>
            </li>
          ))}
        </ul>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="outlined"
        sx={{
          borderColor: "#f44336",
          color: "#f44336",
          "&:hover": {
            borderColor: "#d32f2f",
            backgroundColor: "#fff0f0",
            color: "#d32f2f",
          },
        }}
      >
        {t("button.disagree") || "Disagree"}
      </Button>
      <Button
        onClick={onAgree}
        color="primary"
        variant="contained"
        disabled={isContraScrollable && !isContraScrolledToEnd}
      >
        {t("button.agree") || "Agree"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ContraindicationsModal;
